import { render, staticRenderFns } from "./QueryAsaasIdentifierSidebar.vue?vue&type=template&id=e23853ec"
import script from "./QueryAsaasIdentifierSidebar.vue?vue&type=script&lang=js"
export * from "./QueryAsaasIdentifierSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports